var _defs, _rect, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTecamaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 991.91 999.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9146ff;}.cls-2{fill:#7b20fb;}.cls-3{fill:#4ccafe;}.cls-4{fill:#4bcaff;}.cls-5{fill:#18b2fa;}.cls-6{fill:#7c21fd;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 878.38,
    y: 55.85,
    width: 143.8,
    height: 146.73,
    transform: "translate(-269.13 683.3) rotate(-45)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "404.51 690.88 301.29 794.13 0 492.84 207.02 493.35 404.51 690.88"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "403.6 296.77 207.02 493.35 0 492.84 299.83 193.01 403.6 296.77"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "991.91 491.27 784.38 491.27 691.57 398.46 597.58 492.44 596.41 493.57 391.62 493.57 391 492.95 390.79 492.73 692.08 191.44 991.91 491.27"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "596.41 493.57 494.04 595.95 391.62 493.57 596.41 493.57"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "991.91 491.27 888.14 595.03 784.38 491.27 991.91 491.27"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "991.91 491.71 690.62 793 391.19 493.57 390.79 493.17 391 492.95 391.62 493.57 596.41 493.57 597.58 492.44 691.13 585.98 785.84 491.27 991.47 491.27 991.91 491.71"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 878.83,
    y: 849.52,
    width: 143.8,
    height: 146.73,
    transform: "translate(-830.21 916.07) rotate(-45)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTecamaLogo);
export default __webpack_public_path__ + "static/media/tecama-logo.5f925f2dd05554d64c79a5eb1a356a42.svg";
export { ForwardRef as ReactComponent };